module.exports = __webpack_public_path__ + "img/roket.1c2cd77a.png";